skrilla.directive('saleDetails', function () {
    return {
        templateUrl: 'directives/saleDetails/saleDetails.html',
        scope: {
            sale: "="
        },
        controller: function ($scope, searchService) {

            $scope.approve = function(){
                searchService.put("sales/" + $scope.sale.id + "/approve", {}, "Sale successfully approved!").then(function(response){
                    $scope.sale.status = "APPROVED";
                });
            }

            $scope.decline = function(){
                searchService.put("sales/" + $scope.sale.id + "/decline", {}, "Sale successfully declined!").then(function(response){
                    $scope.sale.status = "DECLINED";
                });
            }

        }
    };
});
